import { AccountProperty } from 'app/services/api/models/AccountProperty';
import { normalizeAccountThemeId } from 'app/constants/accountThemes';
import { initializePropertyRetrieval } from './collection-helper';

export function getThemeColor(accountProperties: Array<AccountProperty>) {
  const getAccountProperty = initializePropertyRetrieval(
    accountProperties,
    'name',
  );
  const accountProperty = getAccountProperty('COLOR_THEME')?.value;

  return normalizeAccountThemeId(accountProperty);
}
